import React from "react";
import PropTypes from "prop-types";

import "./CompanyPanel.css";

function CompanyPanel(props) {
  const { name, address, founded, purpose } = props;

  return (
    <>
      <div className="company__container">
        <div className="company__list">
          <div className="company__left-item">社名</div>
          <div className="company__right-item">{name}</div>
        </div>
        <div className="company__list">
          <div className="company__left-item">本社所在地</div>
          <div className="company__right-item">{address}</div>
        </div>
        <div className="company__list">
          <div className="company__left-item">設立</div>
          <div className="company__right-item">{founded}</div>
        </div>
        <div className="company__list">
          <div className="company__left-item">事業内容</div>
          <div className="company__right-item">{purpose}</div>
        </div>
      </div>
    </>
  );
}

CompanyPanel.propTypes = {
  name: PropTypes.string,
  address: PropTypes.string,
  founded: PropTypes.string,
  purpose: PropTypes.string,
};

export default CompanyPanel;
